import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "label"];

  connect() {
  }

  disconnect() {
  }

  updateLabel() {
    this.labelTarget.innerText = this.inputTarget.value.split("\\").pop();
  }
}
